{
  "conversations": {
    "conversationsApp": "Keskustelusovellus",
    "locationId": "Sijaintitunnus",
    "idToken": "ID-valtuus",
    "conversationRoutes": "Keskustelureitit",
    "conversationProviders": "Keskustelun tarjoajat",
    "viewTheListOfConversation": "Katsoa Luettelo - keskustelu Mukautettu-palveluntarjoajat lisäsivät Tili tässä.",
    "logo": "Logo",
    "name": "Nimi",
    "alias": "Alias",
    "type": "Kirjoittaa"
  }
}
